import React from 'react';
import { CRow } from '@coreui/react';
import CSwitch from '../../../../../migration/CSwitch';
import { CSmartPagination } from '@coreui/react-pro';
import { formatNumber } from '../../../../../../utils/UtilReport';
import PropTypes from 'prop-types';

function PaginationReport({pagination, activePage, totalPages, onPaginationChange, onChangeItemsPerPage, itemsPerPage, handleChangePagination, totalRow, isExploreReport}) {
     return (
          <CRow className={`report-table-bottom ${!pagination ? 'justify-content-end' : ''}`}>
               {pagination && (
                    <div className="d-flex px-0">
                         <CSmartPagination
                              activePage={activePage}
                              pages={totalPages}
                              onActivePageChange={onPaginationChange}
                              className="report-table-page"
                         ></CSmartPagination>
                         <div className="form-inline justify-content-sm-end ml-4">
                              <select className="form-control" onChange={onChangeItemsPerPage} defaultValue={itemsPerPage}>
                                   <option value="5">5</option>
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                   <option value="50">50</option>
                              </select>
                              <label className="ml-2">Items per page {totalRow ? `| ${formatNumber(totalRow)} total ${totalRow > 1 ? `${isExploreReport ? 'records' : 'rows'}` : `${isExploreReport ? 'record' : 'row'}`}` : ''}</label>
                         </div>
                    </div>
               )}
               {!pagination && (
                    <div className="toggle-bottom">
                         <CSwitch
                              className="mx-1"
                              variant="3d"
                              color="primary"
                              checked={pagination ? 'checked' : ''}
                              onChange={(e) => handleChangePagination()}
                              disabled={true}
                         />
                         <span>Paging</span>
                    </div>
               )}
          </CRow>
     );
}


PaginationReport.propTypes = {
     onPaginationChange: PropTypes.func,
     totalPages: PropTypes.number,
     activePage: PropTypes.any,
     handleChangePagination: PropTypes.func,
     pagination: PropTypes.any,
     itemsPerPage: PropTypes.any,
     onChangeItemsPerPage: PropTypes.func,
};

export default PaginationReport;
